import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Grid,
  CardMedia,
  styled,
  Box,
  Paper,
} from "@mui/material";
import React from "react";
import { getImageFolder } from "../Utils/utils";
import image from "../assets/images/NoImage.jpg";
import VerifiedRoundedIcon from "@mui/icons-material/VerifiedRounded";

const StyledCardHeader = styled(CardHeader)(({ theme }) => ({
  "& .MuiCardHeader-content": {
    display: "flex",
    flexDirection: "column",
  },
  "& .MuiCardHeader-title": {
    fontSize: ".95rem",
    fontWeight: "550",
    paddingTop: "5px",
    // color: "#532A0C",
    textTransform: "uppercase",
  },
  "& .MuiCardHeader-subheader": {
    fontSize: ".75rem",
    fontWeight: "100 !important",
    //color: "#532A0C",
  },
}));

const convertToSentenceCase = (str) => {
  if (str === null || str === "") {
    return "";
  }
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export const ProductItemSm = (props) => {
  const {
    id,
    name,
    price,
    imageUrl,
    onOpen,
    description,
    selectedProd,
    ApplyTakeOutDeliveryPrice,
    orderType,
    deliveryprice,
    takeoutprice,
    pricedesc,
    isPizza,
    isDisable,
  } = props;

  return (
    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
      <Paper elevation={6} sx={{ margin: "10px 15px" }}>
        <Card
          onClick={(e) => !isDisable && onOpen()}
          sx={{
            // maxWidth: "216.69px",
            display: "flex",
            flexDirection: "row",
            // padding: "8px",
            paddingLeft: "0px !important",
            // color: `${selectedProd.includes(id) && "#ffffff !important"}`,
            // "& .MuiCardHeader-subheader": {
            //   color: `${selectedProd.includes(id) && "#ffffff !important"}`,
            // },
            backgroundColor: `${isDisable ? "#c7c7c7" : "#ffffff"}`,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <StyledCardHeader
              title={name}
              subheader={convertToSentenceCase(description)}
              sx={{
                paddingLeft: "15px",
                alignItems: "flex-start",
              }}
            />
            <Typography
              variant="button"
              sx={{
                paddingLeft: "15px",
              }}
            >
              {!isPizza
                ? ApplyTakeOutDeliveryPrice === "1"
                  ? orderType === "Delivery" && deliveryprice
                    ? `$${deliveryprice.toFixed(2)}`
                    : orderType === "TakeOut" && takeoutprice
                    ? `$${takeoutprice.toFixed(2)}`
                    : price
                    ? `$${price.toFixed(2)}`
                    : ""
                  : price
                  ? `$${price.toFixed(2)}`
                  : ""
                : pricedesc || ""}
            </Typography>
          </Box>
          <CardMedia
            component="img"
            image={`images/${imageUrl}` || image}
            alt={name}
            sx={{
              maxWidth: "45%",
              maxHeight: "150px",
              width: "45%",
              height: "150px",
              objectFit: "cover",
              // border: "2px solid #972020",
            }}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null;
              currentTarget.src = image;
            }}
          />
          {selectedProd.includes(id) ? (
            <VerifiedRoundedIcon
              sx={{ position: "absolute" }}
              color="success"
            />
          ) : null}
        </Card>
      </Paper>
    </Grid>
  );
};
